/**
 * 동일 작업이 동시에 호출될 때 최초 요청의 Promise를 공유하여 중복 실행을 방지한다.
 * 진행 중인 요청이 성공하거나 실패하면 상태를 초기화하므로 이후 호출은 새 요청을 실행한다.
 *
 * @param {Function} request Promise를 반환하는 비동기 요청 함수
 * @returns {Function} 진행 중인 요청이 있으면 해당 Promise를 반환하는 함수
 */
const singleFlight = (request) => {
  let pendingRequest = null;

  return (...args) => {
    if (!pendingRequest) {
      // 최초 호출만 실제 요청을 실행하고 동시 호출자는 같은 Promise를 전달받는다.
      pendingRequest = request(...args).finally(() => {
        // 성공/실패와 관계없이 완료된 요청을 제거하여 다음 실행을 허용한다.
        pendingRequest = null;
      });
    }

    return pendingRequest;
  };
};

export default singleFlight;
